import React from 'react';

import { Person, CorporateFare } from '@mui/icons-material';

import { gql, type FragmentType, getFragmentData } from '@ivy/gql/types';
import AcepTableSection, {
	type AcepTableSectionProps,
} from '@ivy/views/org/OrgShow/OrgProfile/AcepTableSection';

const AcepInfo_OrgFDoc = gql(/* GraphQL */ `
	fragment AcepInfo_Org on organization {
		id
		surveys: acep_org_surveys(
			where: { accepted_at: { _is_null: false } }
			order_by: [{ accepted_at: desc_nulls_last }]
			limit: 1
		) {
			id
			dba
			nameCmo: name_cmo
		}
	}
`);

export interface AcepInfoProps
	extends Omit<AcepTableSectionProps, 'title' | 'items'> {
	org: FragmentType<typeof AcepInfo_OrgFDoc>;
}

const AcepInfo = ({ org: rawOrg, ...props }: AcepInfoProps) => {
	const org = getFragmentData(AcepInfo_OrgFDoc, rawOrg);

	const survey = org.surveys[0];

	return (
		<AcepTableSection
			items={
				!survey
					? undefined
					: [
							{
								icon: <CorporateFare />,
								label: 'DBA',
								value: survey.dba || 'N/A',
							},
							{
								icon: <Person />,
								label: 'CMO',
								value: survey.nameCmo || 'N/A',
							},
					  ]
			}
			title='Group Information'
			{...props}
		/>
	);
};

export default AcepInfo;
